/*
  Dabi Deri — ürün görselinin üzerinde beliren sepet rozeti.

  Tek düğme, olay delegasyonu ile tema genelinde çalışıyor: imlecin altında
  `/products/...` adresine giden bir bağlantı varsa rozet o bağlantının
  görseline taşınıyor. Kart şablonlarına dokunulmadığı için sonradan
  eklenen bölümlerde ve uygulama bloklarında da kendiliğinden çalışır.

  Ürün bilgisi `/products/<handle>.js` ile okunuyor ve handle başına bir kez
  önbelleğe alınıyor. Duruma göre:
    - tek varyantlı ve satılabilir  -> doğrudan sepete ekler
    - çok varyantlı                -> hızlı incelemeyi açar veya ürüne gider
    - yakında / stokta yok         -> tıklanamaz, "Yakında" der

  Sepete ekleme Craft'ın `product-form` akışını birebir izliyor: bölümler
  istekle birlikte isteniyor ve dönen içerik sepet çekmecesine veriliyor,
  böylece çekmece bayat kalmıyor.
*/

(() => {
  const host = document.querySelector('[data-dabi-addbadge]');
  if (!host) return;

  // Dokunmatikte "üzerine gelme" yok: rozet, ürüne basılı tutunca açılan önizlemeyle birlikte gelir
  // (dabi-card-peek.js → dabi:peek:touch / dabi:peek:touchclose).
  const touchMode = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (touchMode && !document.querySelector('[data-dabi-cardpeek].is-touch, [data-dabi-cardpeek][data-touch="true"]')) return;
  if (touchMode) host.classList.add('is-touch');

  const button = host.querySelector('[data-dabi-addbadge-btn]');
  const tip = host.querySelector('[data-dabi-addbadge-tip]');
  if (!button || !tip) return;

  const cfg = host.dataset;
  const root = cfg.root || '/';

  /* ---------- fiyat rozeti + fiyat kartı ---------- */
  const priceBtn = host.querySelector('[data-dabi-addbadge-price]');
  const pop = document.querySelector('[data-dabi-pricepop]');
  let popOpen = false;

  // Shopify para biçimi (Ayarlar → Mağaza ayrıntıları) birebir uygulanır.
  const formatMoney = (cents) => {
    const fmt = cfg.moneyFormat || '{{amount}}';
    const n = (Number(cents) || 0) / 100;
    const parts = (dec, thou, digits) => {
      const fixed = n.toFixed(digits);
      let [int, frac] = fixed.split('.');
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return frac !== undefined ? `${int}${dec}${frac}` : int;
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = parts('', ',', 0); break;
      case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
      case 'amount_with_apostrophe_separator': out = parts('.', "'", 2); break;
      case 'amount_no_decimals_with_space_separator': out = parts('', ' ', 0); break;
      case 'amount_with_space_separator': out = parts(',', ' ', 2); break;
      case 'amount_with_period_and_space_separator': out = parts('.', ' ', 2); break;
      default: out = parts('.', ',', 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '').trim();
  };

  const variantOf = (product) => {
    const vs = product.variants || [];
    return vs.find((v) => v.available) || vs[0] || null;
  };

  const fillPrice = (product) => {
    if (!priceBtn) return;
    const v = product && variantOf(product);
    if (!v) { priceBtn.hidden = true; return; }
    const now = priceBtn.querySelector('[data-price-now]');
    const was = priceBtn.querySelector('[data-price-was]');
    const off = priceBtn.querySelector('[data-price-off]');
    now.textContent = formatMoney(v.price);
    const onSale = v.compare_at_price && v.compare_at_price > v.price;
    was.hidden = !onSale;
    off.hidden = !onSale;
    if (onSale) {
      was.textContent = formatMoney(v.compare_at_price);
      off.textContent = `-%${Math.round((1 - v.price / v.compare_at_price) * 100)}`;
    }
    priceBtn.classList.toggle('is-sale', !!onSale);
    priceBtn.hidden = false;
  };

  const campaignsFor = (product) => {
    const list = Array.isArray(window.DabiCampaigns) ? window.DabiCampaigns : [];
    const tags = (product.tags || []).map((t) => String(t).toLowerCase().trim());
    const type = String(product.type || '').toLowerCase().trim();
    return list.filter((c) => {
      if (c.all) return true;
      const ctags = (c.tags || []).map((t) => String(t).toLowerCase().trim()).filter(Boolean);
      const ctypes = (c.types || []).map((t) => String(t).toLowerCase().trim()).filter(Boolean);
      const handles = (c.handles || []).filter(Boolean);
      if (handles.includes(product.handle)) return true;
      if (ctags.some((t) => tags.includes(t))) return true;
      if (type && ctypes.includes(type)) return true;
      return false;
    });
  };

  const placePop = () => {
    if (!pop || !current) return;
    const box = host.getBoundingClientRect();
    const w = pop.offsetWidth || 320;
    const h = pop.offsetHeight || 240;
    let x = box.left + box.width / 2 - w / 2;
    let y = box.top - h - 12;
    if (y < 8) y = box.bottom + 12;
    if (y + h > window.innerHeight - 8) y = Math.max(8, window.innerHeight - h - 8);
    x = Math.min(Math.max(x, 8), window.innerWidth - w - 8);
    pop.style.left = `${x}px`;
    pop.style.top = `${y}px`;
  };

  const closePop = () => {
    if (!pop || !popOpen) return;
    popOpen = false;
    pop.classList.remove('is-open');
    window.setTimeout(() => { if (!popOpen) pop.hidden = true; }, 220);
    if (host.dataset.state !== 'busy' && host.dataset.state !== 'done') hide();
  };

  const openPop = async () => {
    if (!pop || !current) return;
    const product = await load(current.handle);
    if (!product || !current) return;
    const v = variantOf(product);
    const img = pop.querySelector('[data-pricepop-img]');
    const image = (v && v.featured_image && v.featured_image.src) || product.featured_image;
    if (image) { img.src = image.includes('?') ? `${image}&width=160` : `${image}?width=160`; img.hidden = false; } else img.hidden = true;
    pop.querySelector('[data-pricepop-title]').textContent = product.title;
    const now = pop.querySelector('[data-pricepop-now]');
    const was = pop.querySelector('[data-pricepop-was]');
    const deal = pop.querySelector('[data-pricepop-deal]');
    now.textContent = v ? formatMoney(v.price) : '';
    const onSale = v && v.compare_at_price > v.price;
    was.hidden = !onSale;
    deal.hidden = !onSale;
    if (onSale) {
      was.textContent = formatMoney(v.compare_at_price);
      const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
      deal.textContent = `${(cfg.labelOff || '%{percent}').replace('{percent}', pct)} · ${(cfg.labelSave || '{amount}').replace('{amount}', formatMoney(v.compare_at_price - v.price))}`;
    }
    const camps = pop.querySelector('[data-pricepop-camps]');
    camps.innerHTML = '';
    const matched = campaignsFor(product);
    if (matched.length === 0 && cfg.labelNocamp) {
      const p = document.createElement('p');
      p.className = 'dabi-pricepop__nocamp';
      p.textContent = cfg.labelNocamp;
      camps.appendChild(p);
    }
    matched.slice(0, 3).forEach((c) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'dabi-pricepop__camp';
      row.innerHTML = `${c.badge ? `<b>${c.badge}</b>` : ''}<span class="dabi-pricepop__camp-title">${c.title}</span>${c.code ? `<span class="dabi-pricepop__camp-code"><small>${cfg.labelCode || ''}</small> ${c.code}</span>` : ''}<span class="dabi-pricepop__camp-go">${cfg.labelDetail || ''}</span>`;
      row.addEventListener('click', () => {
        closePop();
        document.dispatchEvent(new CustomEvent('dabi:campaigns:open', { detail: { id: c.id } }));
      });
      camps.appendChild(row);
    });
    const add = pop.querySelector('[data-pricepop-add]');
    add.hidden = !(v && v.available && (product.variants || []).length === 1);
    pop.querySelector('[data-pricepop-view]').href = current.link.getAttribute('href') || `${root}products/${product.handle}`;
    pop.hidden = false;
    popOpen = true;
    placePop();
    window.setTimeout(() => pop.classList.add('is-open'), 16);
  };

  if (priceBtn && pop) {
    priceBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); if (popOpen) closePop(); else openPop(); });
    pop.querySelector('[data-pricepop-close]')?.addEventListener('click', closePop);
    pop.querySelector('[data-pricepop-add]')?.addEventListener('click', () => { addToCart(); closePop(); });
    document.addEventListener('pointerdown', (e) => {
      if (!popOpen) return;
      if (e.target.closest('[data-dabi-pricepop], [data-dabi-addbadge]')) return;
      closePop();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePop(); });
    window.addEventListener('scroll', () => { if (popOpen) placePop(); }, { passive: true });
  }

  /* Rozetin oturacağı görsel kutusu. Bağlantının içinde ya da dışında
     olabildiği için iki yönde de aranıyor. */
  const MEDIA =
    '.dabi-shelf__media, .dabi-gallery__pop-media, .dabi-gribbon__media, .dabi-iconrail__media, .dabi-product-card__media, .card__media, .card__inner, .media';

  /* Kart kökü: başlık bağlantısının üzerine gelindiğinde de rozet kartın
     görseline otursun, yazının üstüne zıplamasın. */
  const CARD =
    '.dabi-shelf__item, .dabi-gallery__pop-item, .dabi-gribbon__card, .dabi-iconrail__item, .dabi-product-card, .card-wrapper, .card, .grid__item';

  /* Ürün bağlantısı olsa da rozetin çıkmaması gereken yerler. */
  const SKIP =
    'header, .header, .header-wrapper, cart-drawer, cart-notification, .cart-item, .cart-items, .quick-add-modal, .dabi-qv, [data-dabi-no-add], [data-dabi-ticker], .dabi-wsb, .dabi-wsb-block, [data-dabi-deals], .dabi-camphub, .dabi-pricepop';

  const SOON_TAGS = ['yakinda', 'yakında', 'coming-soon', 'coming_soon'];

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cache = new Map();

  let current = null; // { link, anchor, handle, variant }
  let token = 0; // yarış koşulu: geç dönen istek geçerli olanı ezmesin
  let frame = null;

  /* ---------- yardımcılar ---------- */

  const handleOf = (href) => {
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (err) {
      return null;
    }
  };

  const load = (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const request = fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
    cache.set(handle, request);
    return request;
  };

  const anchorFor = (link) => {
    // Onizleme baska bir yerde aciliyorsa rozet de oraya.
    const at = link.dataset.dabiPeekAnchor;
    if (at) {
      const target = document.getElementById(at);
      if (target) return target;
    }
    const inside = link.closest(MEDIA);
    if (inside) return inside;
    const own = link.querySelector(MEDIA);
    if (own) return own;
    const card = link.closest(CARD);
    const media = card && card.querySelector(MEDIA);
    return media || link;
  };

  const isSoon = (product) =>
    (product.tags || []).some((tag) => SOON_TAGS.includes(String(tag).toLowerCase().trim()));

  const setState = (state, label) => {
    host.dataset.state = state;
    tip.textContent = label || '';
    button.setAttribute('aria-label', label || '');
  };

  /* Buyuyen onizleme aciksa rozet buyumus gorselin kosesine otursun.
     Hesap dabi-card-peek.js ile ayni: en az boyut, olcek, kenar siniri. */
  const peekHost = document.querySelector('[data-dabi-cardpeek]');
  const PEEK_SKIP = '.dabi-iconrail, .product__media-list, [data-dabi-no-peek]';

  const grown = (box, anchor) => {
    if (!peekHost || !current || current.link.closest(PEEK_SKIP)) return box;
    // Sigdirilan pencere buyumez; yuvarlaksa rozet dairenin kenarina otursun
    // diye kutu daireye cizilen kareye indiriliyor.
    if (anchor && anchor.hasAttribute('data-dabi-peek-fit')) {
      if (!anchor.hasAttribute('data-dabi-peek-round')) return box;
      // Rozetin merkezi dairenin kenarina (45 derece) gelsin: kutu, rozet
      // yerlestirilirken cikarilan yarim boyut + kenar boslugu kadar genis.
      const half = (host.offsetWidth || 48) / 2;
      const offset = parseFloat(getComputedStyle(host).getPropertyValue('--dabi-ab-offset')) || 10;
      const side = 2 * ((box.width / 2) * Math.SQRT1_2 + half + offset);
      const cx = box.left + box.width / 2;
      const cy = box.top + box.height / 2;
      return { left: cx - side / 2, right: cx + side / 2, top: cy - side / 2, bottom: cy + side / 2, width: side, height: side };
    }
    const scale = Number(peekHost.dataset.scale) || 1;
    const own = current.link.closest('[data-dabi-peek-min]');
    const min = (own && Number(own.dataset.dabiPeekMin)) || Number(peekHost.dataset.min) || 0;
    let w = box.width;
    let h = box.height;
    if (w < min) {
      h *= min / w;
      w = min;
    }
    w *= scale;
    h *= scale;
    let cx = box.left + box.width / 2;
    let cy = box.top + box.height / 2;
    cx = Math.min(Math.max(cx, w / 2 + 8), window.innerWidth - w / 2 - 8);
    cy = Math.min(Math.max(cy, h / 2 + 8), window.innerHeight - h / 2 - 8);
    return { left: cx - w / 2, right: cx + w / 2, top: cy - h / 2, bottom: cy + h / 2, width: w, height: h };
  };

  /* Sabit konumlu, olcekle acilan kart (ikon seridi): gecis sirasinda
     getBoundingClientRect kucuk olcegi verir; kutu style/offset'ten alinir. */
  const rectOf = (anchor) => {
    if (!anchor.hasAttribute('data-dabi-peek-fixed')) return anchor.getBoundingClientRect();
    const w = anchor.offsetWidth;
    const h = anchor.offsetHeight;
    const cx = parseFloat(anchor.style.left) || 0;
    const cy = parseFloat(anchor.style.top) || 0;
    return { left: cx - w / 2, right: cx + w / 2, top: cy - h / 2, bottom: cy + h / 2, width: w, height: h };
  };

  const place = (anchor) => {
    const raw = rectOf(anchor);
    if (raw.width === 0 && raw.height === 0) return hide();
    const box = grown(raw, anchor);
    if (box.width === 0 && box.height === 0) return hide();

    // Urun ekrandan tamamen ciktiysa rozet kenara yapismasin: sayfa
    // kaydirilirken konum yeniden hesaplandigi icin bu durum olusabiliyor.
    if (box.bottom < 0 || box.right < 0 || box.top > window.innerHeight || box.left > window.innerWidth) {
      return hide();
    }

    const size = host.offsetWidth || 48;
    const offset = parseFloat(getComputedStyle(host).getPropertyValue('--dabi-ab-offset')) || 10;
    const half = size / 2;
    let x;
    let y;

    switch (cfg.position) {
      case 'top-right':
        x = box.right - half - offset;
        y = box.top + half + offset;
        break;
      case 'top-left':
        x = box.left + half + offset;
        y = box.top + half + offset;
        break;
      case 'bottom-left':
        x = box.left + half + offset;
        y = box.bottom - half - offset;
        break;
      case 'center':
        x = box.left + box.width / 2;
        y = box.top + box.height / 2;
        break;
      default:
        x = box.right - half - offset;
        y = box.bottom - half - offset;
    }

    // Ekran kenarından taşmasın.
    x = Math.min(Math.max(x, half + 4), window.innerWidth - half - 4);
    y = Math.min(Math.max(y, half + 4), window.innerHeight - half - 4);

    host.style.left = `${x}px`;
    host.style.top = `${y}px`;
    host.classList.toggle('is-flip', y + half + 46 > window.innerHeight);
    host.classList.toggle('is-flip-x', x < 170);
  };

  const hide = () => {
    if (popOpen) return; // fiyat kartı açıkken rozet yerinde kalır
    token += 1;
    current = null;
    host.dabiSource = null;
    host.classList.remove('is-visible');
    if (priceBtn) priceBtn.hidden = true;
  };

  const apply = (product) => {
    if (!product) return hide();
    fillPrice(product);

    if (isSoon(product) || product.available === false) {
      if (cfg.showSoon !== 'true') return hide();
      // stokta yok: "Yakında" değil "Tükendi" (özel sipariş rozeti ayrıca çıkar)
      setState('soon', isSoon(product) ? cfg.labelSoon : (cfg.labelSold || cfg.labelSoon));
      button.setAttribute('aria-disabled', 'true');
      button.removeAttribute('data-qv-open');
      button.removeAttribute('data-product-url');
      return;
    }

    button.removeAttribute('aria-disabled');
    const variants = product.variants || [];

    if (variants.length === 1 && variants[0].available) {
      current.variant = variants[0].id;
      setState('add', cfg.labelAdd);
      button.removeAttribute('data-qv-open');
      button.removeAttribute('data-product-url');
      return;
    }

    // Seçenekli ürün tek tıkla sepete atılamaz: hangi varyant olduğunu
    // müşteri söylemeli. Hızlı inceleme açılıyorsa onun kendi dinleyicisi
    // devralsın diye öznitelikler düğmeye yazılıyor.
    current.variant = null;
    setState('options', cfg.labelOptions);
    if (cfg.optionsAction === 'quick_view') {
      button.setAttribute('data-qv-open', '');
      button.setAttribute('data-product-url', current.link.getAttribute('href') || '');
    } else {
      button.removeAttribute('data-qv-open');
      button.removeAttribute('data-product-url');
    }
  };

  const show = async (link) => {
    const handle = handleOf(link.getAttribute('href'));
    if (!handle) return hide();

    const anchor = anchorFor(link);
    if (current && current.link === link) return;
    if (current && current.anchor === anchor && current.handle === handle) return;

    current = { link, anchor, handle, variant: null };
    host.classList.toggle('is-over-shelf', !!link.closest('[data-dabi-shelf], [data-dabi-sheet-host]') || (touchMode && document.documentElement.classList.contains('is-dabi-sheet'))); // rafın / panelin ve önizlemenin üstünde
    host.dabiSource = link;
    const mine = ++token;

    setState('loading', '');
    if (priceBtn) priceBtn.hidden = true;
    // Sabit kart henuz yerine oturmadiysa (ikon seridi) konum 'dabi:peek:moved'
    // ile gelir; simdi olcmek rozeti ekran disina atardi.
    const pending = anchor.hasAttribute('data-dabi-peek-fixed') && !anchor.classList.contains('is-visible');
    if (!pending) {
      place(anchor);
      if (!current) return; // place(), kutu olcusuz cikarsa gizliyor
      host.classList.add('is-visible');
    }

    const product = await load(handle);
    if (mine !== token || !current) return;
    apply(product);
    place(anchor);
  };

  /* ---------- sepete ekleme ---------- */

  const addToCart = async () => {
    const variant = current && current.variant;
    if (!variant) return;

    setState('busy', cfg.labelAdd);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = new FormData();
    body.append('id', variant);
    body.append('quantity', 1);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    try {
      const url = (window.routes && window.routes.cart_add_url) || `${root}cart/add.js`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);

      setState('done', cfg.labelAdded);

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'dabi-add-badge',
          productVariantId: String(variant),
          cartData: data,
        });
      }
      if (cart && typeof cart.renderContents === 'function') {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }

      window.setTimeout(() => {
        if (host.dataset.state === 'done') setState('add', cfg.labelAdd);
      }, 1800);
    } catch (err) {
      setState('error', cfg.labelError);
      window.setTimeout(() => {
        if (host.dataset.state === 'error') setState('add', cfg.labelAdd);
      }, 2400);
    }
  };

  /* ---------- olaylar ---------- */

  button.addEventListener('click', (event) => {
    const state = host.dataset.state;

    if (state === 'soon' || state === 'loading' || state === 'busy') {
      event.preventDefault();
      return;
    }

    if (state === 'options') {
      if (cfg.optionsAction === 'quick_view' && button.hasAttribute('data-qv-open')) {
        // Tıklama belgeye çıksın: hızlı inceleme kendi dinleyicisiyle açılıyor.
        // Rozet pencerenin üstünde asılı kalmasın diye burada çekiliyor;
        // adres düğmenin özniteliğinde durduğu için dinleyici yine okuyabilir.
        host.classList.remove('is-visible');
        return;
      }
      event.preventDefault();
      const href = current && current.link.getAttribute('href');
      if (href) window.location.assign(href);
      return;
    }

    event.preventDefault();
    addToCart();
  });

  if (!touchMode) {
    document.addEventListener('pointerover', (event) => {
      const t = event.target;
      // özel sipariş rozeti ve baloncuğu: rozet olduğu yerde kalır (rozetin bağlantısı yeni ürün sayılmaz)
      if (t.closest('[data-dabi-addbadge], [data-dabi-peek-ignore], [data-dabi-mto], .dabi-mto-layer')) return;

      const link = t.closest('a[href*="/products/"]');
      if (!link && t.closest('[data-dabi-peek-keep]')) return;
      if (!link || link.closest(SKIP)) {
        if (host.dataset.state !== 'busy' && host.dataset.state !== 'done') hide();
        return;
      }
      show(link);
    });

    document.documentElement.addEventListener('pointerleave', () => {
      if (host.dataset.state !== 'busy' && host.dataset.state !== 'done') hide();
    });
  } else {
    document.addEventListener('dabi:peek:touch', (e) => { if (e.detail && e.detail.link) show(e.detail.link); });
    document.addEventListener('dabi:peek:touchclose', () => { if (host.dataset.state !== 'busy' && host.dataset.state !== 'done') hide(); });
  }

  // Sayfa kaydıkça rozet ürünün üzerinde kalsın.
  const follow = () => {
    frame = null;
    if (current) place(current.anchor);
  };

  const queue = () => {
    if (!current || frame !== null) return;
    frame = window.requestAnimationFrame(follow);
  };

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });

  // Hızlı inceleme açılınca rozet çekilsin: pencerenin üstünde asılı kalırdı.
  document.addEventListener('dabi:quickview:open', hide);

  // Buyuyen kart (ikon seridi) yerine oturunca rozet de onun kosesine gecsin;
  // kart kapaninca rozet de kalksin.
  document.addEventListener('dabi:peek:moved', (event) => {
    if (!current || current.anchor !== event.detail.anchor) return;
    place(current.anchor);
    if (current) host.classList.add('is-visible');
  });
  document.addEventListener('dabi:peek:hidden', (event) => {
    if (current && current.anchor === event.detail.anchor && host.dataset.state !== 'busy' && host.dataset.state !== 'done') hide();
  });

  if (reduceMotion.matches) host.style.transition = 'none';
})();
